import {
  isSWSupported,
  closeDesktopNotification as swCloseDesktopNotification,
  showDesktopNotification as swDesktopNotification,
} from '../sw/sw.js'

import { useNotificationsStore } from 'src/stores/notifications.js'

import { mergePopup } from 'src/services/notification_utils/notification_utils_sw.js'

// the user allows pop-ups from this site
const canNotify = () =>
  'Notification' in window && window.Notification.permission === 'granted'

// without a service worker: the pop-up shown per tag, so a new one of the
// same group can name everyone, and a read one can be closed
const state = { failCreateNotif: false, shown: new Map() }

// the fallback pop-ups a notification id stands in (its own tag, or a
// group naming it), or all of them
const closeShown = (id) => {
  for (const [tag, entry] of state.shown) {
    const matches = id == null || tag === id || entry.data?.ids?.includes(id)
    if (!matches) continue
    entry.popup.close()
    state.shown.delete(tag)
  }
}

export const showDesktopNotification = (desktopNotificationOpts, i18n) => {
  if (!canNotify()) return
  if (useNotificationsStore().desktopNotificationSilence) return

  if (isSWSupported()) {
    swDesktopNotification(desktopNotificationOpts)
  } else if (!state.failCreateNotif) {
    try {
      const { tag } = desktopNotificationOpts
      const popup = mergePopup(
        state.shown.get(tag)?.data,
        desktopNotificationOpts,
        i18n,
      )
      const entry = {
        data: popup.data,
        popup: new window.Notification(popup.title, popup),
      }
      state.shown.set(tag, entry)
      setTimeout(() => {
        // a newer pop-up of the group has taken its place: leave that one
        if (state.shown.get(tag) !== entry) return
        entry.popup.close()
        state.shown.delete(tag)
      }, 5000)
    } catch {
      state.failCreateNotif = true
    }
  }
}

export const closeDesktopNotification = (id) => {
  if (!canNotify()) return
  if (isSWSupported()) swCloseDesktopNotification({ id })
  else closeShown(id)
}

export const closeAllDesktopNotifications = () => {
  if (!canNotify()) return
  if (isSWSupported()) swCloseDesktopNotification({})
  else closeShown(null)
}
